import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SendChangeRequestAction} from '../../components/bank-account-list/send-change-request.action';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {AppConstants} from '../../shared/constants/app-constants';

@Component({
  selector: 'app-change-request-dialog',
  templateUrl: './change-request-dialog.component.html',
  styleUrls: ['./change-request-dialog.component.css']
})
export class ChangeRequestDialogComponent extends SendChangeRequestAction implements OnInit {

  change_request_payload: {
    legal_name: string ,
    ein: string,
    routing_number: string,
    bank_account_number: string,
    type_of_account: string
  } = { legal_name: '', ein: '', routing_number: '', bank_account_number: '', type_of_account: 'both'};
  changeRequestForm: FormGroup;
  constructor(private dialog: MatDialogRef<ChangeRequestDialogComponent>,
              private fb: FormBuilder,
              dataManager: DataManagerService,
              snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) public data: { legal_name: string, ein: any, account_id: string}) {
    super();
    this.dataManager = dataManager;
    this.snackBar = snackBar;
    this.change_request_payload.legal_name = data.legal_name;
    this.change_request_payload.ein = data.ein;
    this._sendChangeRequestUrl = AppConstants.BASE_URL + '/bank-accounts/send-change-request/' + data.account_id;
  }
  routingNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) { return null; }
    if (!/^\d{9}$/.test(value)) {
      return { routingNumberInvalid: true };
    }
    const d = value.split('').map(Number);
    const checksum =
      (3 * (d[0] + d[3] + d[6]) +
        7 * (d[1] + d[4] + d[7]) +
        (d[2] + d[5] + d[8])) % 10;
    return checksum === 0 ? null : { routingNumberInvalid: true };
  }

  get formattedEin(): string {
    const ein = this.changeRequestForm.get('ein')?.value;
    if (!ein) { return ''; }
    const cleaned = ein.replace(/\D/g, '');
    return cleaned.length === 9
      ? `${cleaned.substring(0, 2)}-${cleaned.substring(2)}`
      : ein;
  }

  ngOnInit(): void {
    this.changeRequestForm = this.fb.group({
      legal_name: [ this.change_request_payload.legal_name || '', [Validators.required]],
      ein: [ this.change_request_payload.ein || '', [Validators.required]],
      routing_number: ['', [Validators.required, this.routingNumberValidator]],
      bank_account_number: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.minLength(4),
          Validators.maxLength(17),
        ]
      ],
      type_of_account: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(deposits|fees|both)$/),
        ]
      ],

    });
  }
  closeAction() {
    this.dialog.close(true);
  }
  saveChanges() {
    this.changeRequestForm.markAllAsTouched();
    if (this.changeRequestForm.valid) {
      this.change_request_payload.routing_number = this.changeRequestForm.value.routing_number;
      this.change_request_payload.bank_account_number = this.changeRequestForm.value.bank_account_number;
      this.change_request_payload.type_of_account = this.changeRequestForm.value.type_of_account;
      this.callChangeRequest();
    }
  }
  callChangeRequest() {
    const data = {
      legal_name: this.change_request_payload.legal_name,
      ein: this.change_request_payload.ein,
      routing_number: this.change_request_payload.routing_number,
      bank_account_number: this.change_request_payload.bank_account_number,
      type_of_account: this.change_request_payload.type_of_account
    };
    console.log('Change Request Data', data);
    this.SendChangeRequest(data);
  }

  protected passChangeRequestError(err: any) {
    this.snackBar.open(this.extractErrorMessage(err), 'OK', {
      duration: 0,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['snackbar-error', 'centered-snackbar']
    });
    this.dialog.close(true);
  }


  protected passChangeRequestResponse() {
    this.showSnackBar('Change request for new bank account was sent successfully.', 'OK', 3000);
    this.dialog.close('run');
  }

  private extractErrorMessage(err: any): string {
    return (
      err?.error?.message ||
      err?.error?.errors?.[Object.keys(err?.error?.errors || {})[0]]?.[0] ||
      err?.message ||
      'An unexpected error occurred.'
    );
  }
}
